(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-bottom"]) return;
  try {
    
  document.addEventListener('click', async function(event) {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-sgg-cookie-preferences]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    const status = button.parentElement.querySelector('[role="status"]');
    status.hidden = true;
    button.setAttribute('aria-busy', 'true');
    try {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('Preferences unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      status.hidden = false;
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
